.container {
  padding: 52px 33px;
  background-color: var(--pa-color-footer);

  .tablet({
    padding: 28px 20px;
  });

  .mobile({
    padding: 28px 16px;
  });
}

.hasMargin {
  margin-top: 120px;
}

.content {
  display: grid;
  max-width: @desktop;
  justify-content: center;
  margin: auto;
  color: var(--x-color-white);
  grid-template-areas: "company resources contacts address";

  .tablet({
    max-width: @max-tablet;
  });

  .mobile({
    justify-content: space-around;
    max-width: @max-mobile;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-areas:
    "resources contacts"
    "resources address"
    "company company"
  });
}

.contacts {
  display: flex;
  flex-direction: column;
  padding: 0 70px;
  border-right: 1px solid var(--x-color-text-secondary-darker);
  grid-area: contacts;

  .tablet({
    padding: 0 20px;
  });

  .mobile({
    border-right: none;
    padding: 0 12px;
    align-items: center;
  });
}

.address {
  display: flex;
  flex-direction: column;
  padding: 0 70px;
  grid-area: address;

  .tablet({
    padding: 0 20px;
  });

  .mobile({
    padding: 0 12px;
    align-items: center;
  });

  > span {
    line-height: 26px;

    .mobile({
      padding-left: 0;
    });
  }
}

.company {
  display: flex;
  flex-direction: column;
  padding: 0 70px;
  border-right: 1px solid var(--x-color-text-secondary-darker);
  grid-area: company;

  .tablet({
    padding: 0 20px;
  });

  .mobile({
    border-right: none;
    border-top: 1px solid var(--x-color-text-secondary-darker);
    margin-top: 28px;
    padding-top: 28px;
    align-items: center;
  });
}

.resources {
  display: flex;
  flex-direction: column;
  padding: 0 70px;
  border-right: 1px solid var(--x-color-text-secondary-darker);
  grid-area: resources;
  white-space: nowrap;

  .tablet({
    padding: 0 20px;
  });

  .mobile({
    padding: 0 12px;
    white-space: normal;
    align-items: center;
  });
}

.resources,
.contacts {
  a {
    color: var(--x-color-white);

    &:hover {
      color: #f3f6f8;
      text-decoration: underline;
    }
  }
}

.titleContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 19px;
  white-space: nowrap;
}

.left {
  justify-content: start;
}

.title {
  color: var(--x-color-white);
  font-size: 13px;
}

.logo {
  margin-right: 13px;
}

.info {
  color: #8c94a0;
  .mobile({
    padding-left: 32px;
  });
}

.locationIcon {
  .mobile({
    display: none;
  });
}

.resourcesList,
.contactsList {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.generalChatButton {
  color: var(--x-color-white);
  font-weight: 400;
}

.street {
  white-space: nowrap;

  .mobile({
    white-space: normal;
  });
}

.email {
  // the support address has no natural break points; let it wrap inside a narrow column
  overflow-wrap: anywhere;
}
